import { Rule } from 'antd/lib/form';
import validator from 'validator';

export const validateEmail: Rule = () => ({
    validator(_, value) {
        if (!value) {
            return Promise.resolve();
        } else if (!validator.isEmail(value)) {
            return Promise.reject("invalid email address format");
        } else {
            return Promise.resolve();
        }
    },
});

export const validateFullName: Rule = () => ({
    validator(_, value) {
        if (!value) {
            return Promise.resolve();
        } else if (!/^[A-Za-z0-9\u0600-\u06FF\s]+$/u.test(value)) {
            return Promise.reject("Invalid full name format");
        } else {
            return Promise.resolve();
        }
    },
});

export const validatePhoneNumber: Rule = () => ({
    validator(_, value) {
        if (!value) {
            return Promise.resolve();
        } else if (!validator.isNumeric(value)) {
            return Promise.reject("invalid phone number format")
        } else
            return Promise.resolve()
    }
});